"use strict";
// All the learning stage and difficulty level related constants
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizeSection = exports.SECTION_DISPLAY_TITLES = exports.SECTION_SHORT_HEADERS = exports.SECTIONS = exports.difficultyToCssClass = exports.ASSIGNED_DIFFICULTIES = void 0;
var ASSIGNED_DIFFICULTIES;
(function (ASSIGNED_DIFFICULTIES) {
    ASSIGNED_DIFFICULTIES["EMERGING"] = "Emerging";
    ASSIGNED_DIFFICULTIES["INTERMEDIATE"] = "Intermediate";
    ASSIGNED_DIFFICULTIES["ADVANCED"] = "Advanced";
})(ASSIGNED_DIFFICULTIES || (exports.ASSIGNED_DIFFICULTIES = ASSIGNED_DIFFICULTIES = {}));
exports.difficultyToCssClass = {
    [ASSIGNED_DIFFICULTIES.EMERGING]: 'emerging',
    [ASSIGNED_DIFFICULTIES.INTERMEDIATE]: 'intermediate',
    [ASSIGNED_DIFFICULTIES.ADVANCED]: 'advanced',
    'Not assigned': 'notAssigned'
};
// This is defined in the Eduquery API
var SECTIONS;
(function (SECTIONS) {
    SECTIONS["PRE_ASSESSMENT"] = "pre_assessment";
    SECTIONS["POST_ASSESSMENT"] = "post_assessment";
    SECTIONS["CHECK_FOR_UNDERSTANDING"] = "check_for_understanding";
    SECTIONS["INDEPENDENT_WORK"] = "independent_work";
})(SECTIONS || (exports.SECTIONS = SECTIONS = {}));
// This is used in the lesson overview table
exports.SECTION_SHORT_HEADERS = {
    [SECTIONS.PRE_ASSESSMENT]: 'PreAQs',
    [SECTIONS.CHECK_FOR_UNDERSTANDING]: 'Check Qs',
    [SECTIONS.INDEPENDENT_WORK]: 'Indep. Qs',
    [SECTIONS.POST_ASSESSMENT]: 'PostAQs',
};
// Display titles for sections used in presentation/live views
exports.SECTION_DISPLAY_TITLES = {
    [SECTIONS.PRE_ASSESSMENT]: 'Pre-Assessment Questions',
    [SECTIONS.CHECK_FOR_UNDERSTANDING]: 'Check for Understanding',
    [SECTIONS.INDEPENDENT_WORK]: 'Independent Work',
    [SECTIONS.POST_ASSESSMENT]: 'Post-Assessment Questions',
};
// TODO:Rename/standardize later
const normalizeSection = (stage) => {
    switch (stage) {
        case 'Pre-Assessment': return SECTIONS.PRE_ASSESSMENT;
        case 'Post-Assessment': return SECTIONS.POST_ASSESSMENT;
        case 'Check for Understanding': return SECTIONS.CHECK_FOR_UNDERSTANDING;
        case 'Independent Work': return SECTIONS.INDEPENDENT_WORK;
        default: return stage;
    }
};
exports.normalizeSection = normalizeSection;
